define(function () {});



/** WEBPACK FOOTER **
 ** ./target/js/widget/empty.js
 **/